import { ArrowCounterClockwise } from "@phosphor-icons/react"
import { formatNumber } from "~/utils/formatting"
import HoverCardRow from "../reusable/hovercard/HoverCardRow"

/** Forecasted customer returns, counted as supply in a stock breakdown. Hidden when there are none. */
export function ExpectedReturnsRow({ quantity }: { quantity: number }) {
  if (quantity <= 0) return null
  return (
    <HoverCardRow
      icon={<ArrowCounterClockwise />}
      label="Expected returns"
      value={`+${formatNumber(quantity)} units`}
      className="text-fg-positive-text"
    />
  )
}
